import React from 'react';
import Markdown from 'react-markdown';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

function SoftwareResources({ data, slug }) {
    return (
        <div key={data.documentId} className={"screen-width software-resources".concat(slug === 'school-program' ? ' school-program-software-resources' : '')}
             style={ slug === 'school-program' ? { display: 'flex'} : {marginLeft: '-60px'}}>

            <div className={slug === 'school-program' ? 'col-sm-2' : ''}></div>
            <div style={slug==='school-program' ? {width: '100%', display: 'flex', justifyContent: "center"} : null}>
                <div className={slug === 'school-program' ? 'col-sm-10 col-xs-12' : ''} style={{maxWidth: slug==='school-program' ? '1100px' : ''}}>

                    {data.softwareResources.map((softwareResource, softwareResourceIdx) => (

                        <div key={ softwareResourceIdx } className="views-row views-row-2 views-row-even">

                            <div className="row background-full-width software-resource-div vertical-align " id={ softwareResource.title.replaceAll(" ", "") }>

                                <div className="container-fluid software-resources-container" style={{ margin: "0 auto", maxWidth: "1410px", padding: "0 40px" }}>
                                    <div className={"no-padding ".concat(slug === 'school-program' ? 'col-lg-6 col-xs-12' : 'col-lg-4 col-xs-12')}>
                                        <div className={"software-resource-block ".concat(slug === 'school-program' ? 'download-curriculum-text': '')}>

                                            <p className="section-headline-small light-blue-text">
                                                { softwareResource.title }
                                            </p>

                                            <p className="body-text">
                                                <Markdown>{ softwareResource.paragraph.replaceAll('\n','  \n') }</Markdown>
                                            </p>

                                            {softwareResource.resourceLinks.map((resourceLink, resourceLinkIdx) => (
                                                <div className="download-link">
                                                    <div className="software-resource-link resource-link">
                                                        <strong><a href={ resourceLink.url } target="_blank">{ resourceLink.label }</a></strong>
                                                        {/*FIXME: Point the image icon to the new webapp asset*/}
                                                        <img alt="download-arrow" style={{height: "15px", width: "30px", fill: "currentColor", display: "inline"}} src="https://www.cleanairpartners.net/sites/default/files/03%20ui%20elements/linkarrow.svg" />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className={"software-resource-images ".concat(slug === 'school-program' ? 'col-lg-6 col-xs-12' : 'col-lg-8 col-xs-12')}>
                                        {softwareResource.images.map((image, imageIdx) => (
                                            <div key={ imageIdx } className="software-image">
                                                <img alt="resource-image" className="img-responsive" src={ image.url } />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default SoftwareResources;
